import { Suspense, lazy } from 'react';

const PersonDetails = lazy(() => import('../components/People/PersonDetails'));

const PersonDetailsLazy: React.FC = () => {
    return <Suspense><PersonDetails/></Suspense>;
}

export default PersonDetailsLazy;
